import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { Grid } from "@bw/bits"
import { breakpoints } from "../../../theme"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import MiniCarousel from "./MiniCarousel"

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  > :nth-child(2) {
    margin-top: 15px;
  }

  .column-image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 1rem auto;
    width: 300px;
    height: 300px;
    overflow: hidden;
  }

  .column-image img,
  .column-image > .gatsby-image-wrapper,
  .column-image > .gatsby-image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    flex-direction: column;
    align-items: center;
    display: block;
  }

  .column-content {
    margin-top: 0.5rem;
    text-align: center;
  }

  @media (max-width: ${breakpoints.small || "768px"}) {
    .column-image img,
    .column-image > .gatsby-image-wrapper {
      max-width: 200px;
    }
  }
`

//const CarouselWrap = styled.div`
//  position: relative;
//  overflow: hidden;
//  width: 100%;
//  .slides {
//    display: flex;
//    transition: transform 300ms ease;
//    will-change: transform;
//  }
//  .slide {
//    min-width: 100%;
//    box-sizing: border-box;
//    padding: 0.5rem;
//    display: flex;
//    justify-content: center;
//  }
//  .carousel-image {
//    max-width: 220px; /* <-- même taille que image principale */
//    width: 100%;
//    height: auto;
//    border-radius: 6px;
//    object-fit: contain;
//  }
//  .controls {
//    position: absolute;
//    top: 50%;
//    left: 0;
//    right: 0;
//    display: flex;
//    justify-content: space-between;
//    transform: translateY(-50%);
//    pointer-events: none;
//  }
//  .controls button {
//    pointer-events: all;
//    background: rgba(255,255,255,0.7);
//    border: none;
//    padding: 0.25rem 0.5rem;
//    margin: 0 0.25rem;
//    border-radius: 4px;
//    cursor: pointer;
//  }
//  .dots {
//    display:flex;
//    justify-content:center;
//    gap:6px;
//    margin-top: 0.4rem;
//  }
//  .dot {
//    width:8px;
//    height:8px;
//    border-radius:50%;
//    background: #ccc;
//  }
//  .dot.active {
//    background: #333;
//  }
//`

/*function renderImage(image) {
  if (!image) return null
  try {

    if (image.localImage && image.localImage.childImageSharp) {
      return <GatsbyImage image={getImage(image.localImage.childImageSharp)} alt={image.alt || ""} />
    }

    if (image.url) return <img src={image.url} alt={image.alt || ""} />
  } catch (e) {
    console.error("Error rendering image:", e)
  }
  
  return null
}*/

function renderImage(image) {
  if (!image) return null

  try {
    if (image.localImage) {
      const gatsbyImg = getImage(image.localImage)
      if (gatsbyImg) {
        return <GatsbyImage image={gatsbyImg} alt={image.alt || ""} />
      }
    }

    if (image.childImageSharp) {
      const gatsbyImg = getImage(image)
      if (gatsbyImg) {
        return <GatsbyImage image={gatsbyImg} alt={image.alt || ""} />
      }
    }

    if (image.url) {
      return <img src={image.url} alt={image.alt || ""} />
    }

    if (typeof image === "string") {
      return <img src={image} alt="" />
    }

  } catch (e) {
    console.error("Error rendering image:", e)
  }

  return null
}



//const MiniCarousel = ({ slides = [], auto = true, autoDelay = 4000 }) => {
//  const [index, setIndex] = useState(0)
//  const slidesCount = slides.length || 0
//  const timerRef = useRef(null)
//
//  useEffect(() => {
//    if (!auto || slidesCount <= 1 || typeof window == "undefined") return
//    timerRef.current = window.setInterval(() => {
//      setIndex(i => (i + 1) % slidesCount)
//    }, autoDelay)
//
//    return () => {
//      if (timerRef.current) {
//        clearInterval(timerRef.current)
//      }  
//    }
//  }, [auto, slidesCount, autoDelay])
//
//  if (!slidesCount) return null
//
//  const prev = () => setIndex(i => (i - 1 + slidesCount) % slidesCount)
//  const next = () => setIndex(i => (i + 1) % slidesCount)
//
//  return (
//    <CarouselWrap>
//      <div
//        className="slides"
//        style={{ transform: `translateX(-${index * 100}%)` }}
//      >
//        {slides.map((s, i) => (
//            <div className="slide" key={i}>
//              {renderImage(s.image)}
//            </div>
//        ))}
//      </div>
//
//      {slidesCount > 1 && (
//        <>
//          <div className="controls" aria-hidden>
//            <button onClick={prev} aria-label="Précédent">‹</button>
//            <button onClick={next} aria-label="Suivant">›</button>
//          </div>
//
//          <div className="dots" role="tablist" aria-hidden>
//            {slides.map((_, i) => (
//              <div 
//                key={i}
//                role="button"
//                tabIndex={0}
//                aria-label={`Aller au slide ${i + 1}`}
//                className={`dot ${i === index ? "active" : ""}`}
//                onClick={() => setIndex(i)}
//                onKeyDown={(e) => e.key === "Enter" && setIndex(i)}
//              />
//            ))}
//          </div>
//        </>
//      )}
//    </CarouselWrap>
//  )
//}

const Columns = ({ count, contents }) => {

  if (!Array.isArray(contents) || contents.length === 0) return null

  return (
    <Grid columns={count}>
      {contents.map((item, i) => {
        const isLast = i === contents.length - 1
        const hasCarousel = Array.isArray(item.carousel) && item.carousel.length > 0

        return(
          <Column key={i}>

            {isLast && hasCarousel ? (
              // Affiche uniquement le mini carousel si carousel existe
              <div className="column-image">
                <MiniCarousel
                  slides={item.carousel}
                  auto={true}
                  autoDelay={4000}
                />
              </div>
            ) : (
              // Si pas de carousel
              <div>
                {item.image && (
                  <div className="column-image">
                    {renderImage(item.image)}
                  </div>
                )}
                {item.title && <h3>{item.title}</h3>}
                {item.content && <div className="column-content">{item.content}</div>}
              </div>
            )}

          </Column>
        )
      })}
    </Grid>
  )
}

Columns.propTypes = {
  count: PropTypes.number,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.node,
      image: PropTypes.object,
      carousel: PropTypes.arrayOf(PropTypes.object),
    })
  ),
}

Columns.defaultProps = {
  count: 2,
}

export { Columns }
export default Columns